export default {"src":"/_next/static/media/TELL.7599a6e1.svg","height":18,"width":18};